import { styled } from '@mui/material/styles';
import { isNil } from 'ramda';

import AuxValuesEditForm from './AuxValuesEditForm';
import AuxValuesForm from './AuxValuesForm';

import type { IAuxValuesFormProps } from './AuxValuesForm';

const PREFIX = 'EditOrCreate';

const classes = {
  root: `${PREFIX}-root`
};

const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {
    minWidth: 400
  }
}));

const EditOrCreate = ({ rowId, ...props }: IAuxValuesFormProps) => {
  'use memo';

  return (
    <Root className={classes.root}>
      {isNil(rowId) ? (
        <AuxValuesForm {...props} rowId={rowId} />
      ) : (
        <AuxValuesEditForm {...props} rowId={rowId} />
      )}
    </Root>
  );
};

export default EditOrCreate;
